import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { WhitelabelListItem } from '@/models/dictionary/whitelabel-list.model';

export default class GetWhitelabelListRequest extends ApiResourceMethod<WhitelabelListItem[]> {
  public perform(): Promise<WhitelabelListItem[]> {
    return this.performer.requestWithMapper(
      {},
      ({ data }: BaseResponse<WhitelabelListItem[]>): WhitelabelListItem[] => data,
    );
  }
}
